import type { RouteObject } from 'react-router';
import { READABLE_OFFLINE } from '../../core/pwa/works-offline';

/**
 * `/review`. One lazy chunk holding one screen, the same shape `archive.routes.tsx` uses for
 * `/done` — no list/detail split, because the review screen *is* the list.
 *
 * 036 (issue 221, FR-021): readable offline. Its one read (`GET /projects?pageSize=500&state=all`)
 * is byte-identical to the projects list's own, already on the allow-list.
 */
export const routes: RouteObject[] = [
  {
    index: true,
    handle: { [READABLE_OFFLINE]: true },
    lazy: async () => ({ Component: (await import('./review-page')).default }),
  },
];
